// Sign Method
export const GET_LIST_SIGN_METHOD = "GET_LIST_SIGN_METHOD";
export const GET_LIST_SIGN_METHOD_SUCCESS = "GET_LIST_SIGN_METHOD_SUCCESS";
export const GET_LIST_SIGN_METHOD_FAIL = "GET_LIST_SIGN_METHOD_FAIL";
export const RESET_LIST_SIGN_METHOD = "RESET_LIST_SIGN_METHOD";

// Chi tiết Sign Method
export const GET_DETAIL_SIGN_METHOD = "GET_DETAIL_SIGN_METHOD";
export const GET_DETAIL_SIGN_METHOD_SUCCESS = "GET_DETAIL_SIGN_METHOD_SUCCESS";
export const GET_DETAIL_SIGN_METHOD_FAIL = "GET_DETAIL_SIGN_METHOD_FAIL";
export const RESET_DETAIL_SIGN_METHOD = "RESET_DETAIL_SIGN_METHOD";

// Tạo Sign Method
export const CREATE_SIGN_METHOD = "CREATE_SIGN_METHOD";
export const CREATE_SIGN_METHOD_SUCCESS = "CREATE_SIGN_METHOD_SUCCESS";
export const CREATE_SIGN_METHOD_FAIL = "CREATE_SIGN_METHOD_FAIL";
export const RESET_CREATE_SIGN_METHOD = "RESET_CREATE_SIGN_METHOD";

// Tạo lsit Sign Method
export const CREATE_LIST_SIGN_METHOD = "CREATE_LIST_SIGN_METHOD";
export const CREATE_LIST_SIGN_METHOD_SUCCESS =
  "CREATE_LIST_SIGN_METHOD_SUCCESS";
export const CREATE_LIST_SIGN_METHOD_FAIL = "CREATE_LIST_SIGN_METHOD_FAIL";
export const RESET_CREATE_LIST_SIGN_METHOD = "RESET_CREATE_LIST_SIGN_METHOD";

// EDIT Sign Method
export const EDIT_SIGN_METHOD = "EDIT_SIGN_METHOD";
export const EDIT_SIGN_METHOD_SUCCESS = "EDIT_SIGN_METHOD_SUCCESS";
export const EDIT_SIGN_METHOD_FAIL = "EDIT_SIGN_METHOD_FAIL";
export const RESET_EDIT_SIGN_METHOD = "RESET_EDIT_SIGN_METHOD";

// delete Sign Method
export const DELETE_SIGN_METHOD = "DELETE_SIGN_METHOD";
export const DELETE_SIGN_METHOD_SUCCESS = "DELETE_SIGN_METHOD_SUCCESS";
export const DELETE_SIGN_METHOD_FAIL = "DELETE_SIGN_METHOD_FAIL";
export const RESET_DELETE_SIGN_METHOD = "RESET_DELETE_SIGN_METHOD";

// Get list tsuat
export const GET_LIST_VAT = "GET_LIST_VAT";
export const GET_LIST_VAT_SUCCESS = "GET_LIST_VAT_SUCCESS";
export const GET_LIST_VAT_FAIL = "GET_LIST_VAT_FAIL";
export const RESET_GET_LIST_VAT = "RESET_GET_LIST_VAT";

// GET_ALL_SIGN_METHOD
export const GET_ALL_SIGN_METHOD = "GET_ALL_SIGN_METHOD";
export const GET_ALL_SIGN_METHOD_SUCCESS = "GET_ALL_SIGN_METHOD_SUCCESS";
export const GET_ALL_SIGN_METHOD_FAIL = "GET_ALL_SIGN_METHOD_FAIL";
export const RESET_GET_ALL_SIGN_METHOD = "RESET_GET_ALL_SIGN_METHOD";

//
export const SET_COLUMN_VISIBLE_SIGN_METHOD = "SET_COLUMN_VISIBLE_SIGN_METHOD";
